import React, { useRef } from 'react';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import * as echarts from 'echarts/core';
import {
  breakpointsMediaQuery,
  getColor,
  useMediaQuery
} from '@/helpers/utils';
import { BarChart } from 'echarts/charts';
import {
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent
} from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
import { Card } from 'react-bootstrap';
import { FaDesktop, FaMobileScreenButton } from 'react-icons/fa6';
import CustomLegent from '@/app/common/components/charts/CustomLegent';
import numberHumanizer from '@/helpers/numberHumanizer';
import FalconCardHeader from '@/components/common/FalconCardHeader';
import ToggleButton from 'react-bootstrap/ToggleButton';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import { useTooltipHide } from '@/hooks/useTooltipHide';
import countSuffix from '@/helpers/countSuffix';

echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  BarChart,
  CanvasRenderer,
  LegendComponent
]);

const EstimateClickChart = ({ data, viewChartMode, setViewChartMode }) => {
  /*کانفیگ های مربوط به نمودار */
  const chartRef = useRef();
  const isMdUp = useMediaQuery(breakpointsMediaQuery.md);
  useTooltipHide(chartRef);
  const getOption = data => ({
    textStyle: {
      fontFamily: 'dana'
    },
    // نحوه نمایش تولتیپ نمودار
    tooltip: {
      triggerOn: isMdUp ? 'mousemove' : 'click',
      trigger: 'item',
      padding: [7, 10],
      backgroundColor: getColor('gray-100'),
      borderColor: getColor('gray-300'),
      textStyle: { color: getColor('gray-1100'), fontSize: '15px' },
      borderWidth: 1,
      formatter: params => {
        return `<div>
        <span>${params.marker}</span>
          <span class="fw-bolder">
          ${params.seriesName}:
          </span>
          <span>${numberHumanizer(params.data)}</span>
          </div>`;
      },
      transitionDuration: 0,
      axisPointer: {
        type: 'none'
      }
    },
    legend: {
      show: false,
      icon: 'circle',
      padding: [0, 0, 0, 0],
      bottom: 0,
      textStyle: {
        color: getColor('gray-600')
      }
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '20%',
      top: '0%',
      containLabel: true
    },
    xAxis: {
      type: 'value',
      axisLabel: {
        color: getColor('gray-400'),
        fontWeight: 600,
        fontSize: 10,
        margin: 15,
        interval: window.innerWidth < 768 ? 'auto' : 0,
        formatter: value => (isMdUp ? value : countSuffix(value))
      }
    },
    yAxis: {
      type: 'category'
    },
    series: data
  });

  return (
    <Card className="mb-3">
      <FalconCardHeader
        titleTag="h6"
        className="py-2"
        endEl={
          <ToggleButtonGroup
            size="sm"
            type="radio"
            name="options"
            onChange={setViewChartMode}
            defaultValue={'desktop'}
          >
            <ToggleButton
              id="tbg-radio-desktop"
              variant="outline-primary"
              value={'desktop'}
            >
              <FaDesktop />
            </ToggleButton>
            <ToggleButton
              id="tbg-radio-mobile"
              variant="outline-primary"
              value={'mobile'}
            >
              <FaMobileScreenButton />
            </ToggleButton>
          </ToggleButtonGroup>
        }
        light
        title="نموار تخمین کلیک بر اساس رتبه"
      />
      <Card.Body>
        <ReactEChartsCore
          ref={chartRef}
          echarts={echarts}
          option={getOption(data)}
          style={{ height: '8rem' }}
        />
      </Card.Body>
      <div className="d-flex mx-1 mt-n4 mb-3 gap-2 justify-content-center pt-1 align-items-center flex-wrap">
        {data?.map(item => (
          <CustomLegent
            key={item.name}
            name={item.name}
            chartRef={chartRef}
            color={item.itemStyle.color}
          />
        ))}
      </div>
    </Card>
  );
};

export default EstimateClickChart;
